import { styled } from "styled-components";
import { devices } from "@/constants/media";
import { ROOM_BUTTONS_HEIGHT } from "@/constants/ui";

export const StyledRoomControls = styled.div`
  height: ${ROOM_BUTTONS_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-lg);
  position: sticky;
  bottom: 0;
  padding-bottom: var(--spacing-md);
  background-color: var(--color-background-dark);
  z-index: 5;
  padding: 0 var(--spacing-md);
  @media ${devices.sm} {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: var(--spacing-sm);
  }
`;

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: calc(var(--spacing-sm) + var(--spacing-xs));
  flex: 1;
  &:nth-child(2) {
    justify-content: center;
    flex: 2;
  }
  &:nth-child(3) {
    justify-content: flex-end;
  }
  @media ${devices.sm} {
    &:nth-child(1) {
      justify-content: center;
    }
    gap: var(--spacing-sm);
  }
`;
